/**
 * 줄간격를 구하는 함수입니다.
 *
 * 1 ~ 5단계(lineHeightLevel)이며, 2단계가 기본값(DEFAULT_LINE_HEIGHT = 1.6)입니다.
 */
export function getTextViewerLineHeight(lineHeightLevel: number) {
  const lineHeightIndex = Math.max(
    Math.min(lineHeightLevel - 1, LINE_HEIGHT_LIST.length),
    0
  );
  return LINE_HEIGHT_LIST[lineHeightIndex];
}

const LINE_HEIGHT_LIST = [1.2, 1.6, 1.8, 2.0, 2.4];
